<template>
  <div id="app">
    <contenful-apis
      url="spaces/uhuxxitrg1zr/entries"
      :params="{ content_type: 'websiteMeta', include: 3 }"
      :key-path="['websiteMeta']"
    />
    <header-component/>
    <router-view/>
    <footer-component/>
  </div>
</template>

<script>
import HeaderComponent from "./components/header/index.vue";
import FooterComponent from "./components/footer";
import { actions } from "vuex-api";

export default {
  components: {
    FooterComponent,
    HeaderComponent
  },
  created: function() {
    const token = localStorage.getItem("token");
    if (token) {
      this.$store.dispatch(actions.request, {
        requestConfig: {
          baseURL: process.env.VUE_APP_API_URL
        },
        method: "GET",
        url: "/api/users/me",
        headers: { Authorization: `Bearer ${token}` },
        keyPath: ["me"]
      });
    }
  },
  name: "App"
};
</script>

<style lang="scss">
@import "main";
</style>
